<template lang="pug">
  div(:class="`component-card-${columns}`")
    .columns
      .row.align-middle
        .columns.shrink.align-self-middle(v-if="showBullets")
          slot(name="actionBullets")
        .columns
          .row
            .columns(v-for="n in columns", :class="{'shrink': shouldShrink('n'+n)}").align-self-middle
              slot(:name="'n'+n")
        .columns.shrink.align-self-middle(v-if="showAction")
          slot(name="actionPage")
      .row
        slot(name="bottom")

</template>
<script type="text/babel">
    export default {
        name: 'CardN',
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {
            actionClicked() {
                this.$emit('actionClicked')
            },
            bulletsClicked() {
                this.$emit('bulletsClicked')
            },
            shouldShrink(slot) {

                var t = false
                if (this.shrink) {

                    this.shrink.forEach((item) => {

                        if (item[slot]) {
                            t = true
                        }
                    })
                }

                return t
            }
        },
        computed: {},
        props: ['showBullets', 'showAction', 'shrink', 'columns']
    }
</script>

<style lang="sass" rel="stylesheet/sass">
  .action
    cursor: pointer
</style>



// WEBPACK FOOTER //
// CardN.vue?f6cecad4